export default __webpack_public_path__ + "static/backhoes-jcb-ef4549ad07b8c38d6d38e93e6137bd94.png";